<template>
    <div class="filter-period">
        <div class="filter-label" @click="showOptions = !showOptions">
            <span class="far fa-map-marker"></span> {{ valueLabel }}
        </div>
        <div
            class="filter-options"
            v-if="showOptions"
            v-click-outside="clickedOutsideOptions"
        >
            <ul>
                <li
                    @click.prevent="toggleBranch(branch.id)"
                    v-for="branch in branches"
                    :key="branch.id"
                >
                    <input
                        type="checkbox"
                        :checked="isChecked(branch.id)"
                        :id="`filter-${name}-${branch.id}`"
                        :name="name"
                    />
                    <label :for="`filter-${name}-${branch.id}`">{{ branch.title }}</label>
                </li>
            </ul>
            <div class="filter-actions">
                <button
                    type="button"
                    class="cancelBtn btn btn-sm btn-default"
                    @click="cancel"
                >
                    {{ t('reportFilters-cancel') }}
                </button>
                <button
                    type="button"
                    class="applyBtn btn btn-sm btn-success"
                    @click="apply"
                >
                    {{ t('reportFilters-apply') }}
                </button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "filter-branch",
    props: {
        name: {
            type: String,
            default: "filter-branch",
        },
        currentValue: {
            type: [Array, String, Number],
            default: null,
        },
    },
    data() {
        return {
            showOptions: false,
            clickedOutsideOptions: () => {},
            value: [],
            newValue: [],
            changedValue: false,
        };
    },
    mounted() {
        if (this.currentValue) {
            this.value = this.currentValue;
            this.newValue = [...this.value];
        }
        if (this.value.length > 0) {
            this.changed();
        }
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        toggleBranch(id) {
            let idx = this.newValue.indexOf(id);
            if (idx === -1) {
                this.newValue.push(id);
            } else {
                this.newValue.splice(idx, 1);
            }
        },
        isChecked(id) {
            return this.newValue.indexOf(id) !== -1;
        },
        apply() {
            this.value = [...this.newValue];
            this.showOptions = false;
        },
        cancel() {
            this.newValue = [...this.value];
            this.showOptions = false;
        },
        changed() {
            this.$emit("changed", this.value.length > 0 ? this.value : null);
        },
    },
    computed: {
        valueLabel() {
            if (this.value.length === 0) {
                return this.t('reportFilters-select_branches');
            }
            let label = this.value.map((id) => this.branchesMap[id]).join(", ");
            if (label.length > 30) {
                label = label.substr(0, 27) + "...";
            }
            return label;
        },
        branchesMap() {
            let branchesMap = {};
            for (let b in this.branches) {
                let branch = this.branches[b];
                branchesMap[branch.id] = branch.title;
            }
            return branchesMap;
        },
        branches() {
            return this.$store.state.place.branches.filter((b) =>
                parseInt(b.active),
            );
        },
    },
    watch: {
        showOptions() {
            if (this.showOptions) {
                window.setTimeout(() => {
                    this.clickedOutsideOptions = () => {
                        if (this.showOptions) {
                            this.cancel();
                        }
                    };
                }, 100);
            } else {
                this.clickedOutsideOptions = () => {};
            }
        },
        value() {
            this.changed();
        },
    },
};
</script>
